import "./../sass/style.scss";
import "bootstrap";
import fontawesome from "@fortawesome/fontawesome";
import light from "@fortawesome/fontawesome-pro-light";
import brands from "@fortawesome/fontawesome-free-brands";
import Flickity from "flickity";
import Headroom from "headroom.js";
import "isotope-layout/dist/isotope.pkgd.js";
import "lightgallery/dist/js/lightgallery-all";
import "imagesloaded/imagesloaded.pkgd.js";
import "select2/dist/js/select2.js";

fontawesome.library.add(light);

jQuery(function ($) {
  "use strict";

  function preventDefault(e) {
    e = e || window.event;
    if (e.preventDefault) e.preventDefault();
    e.returnValue = false;
  }

  function keydown(e) {
    for (var i = keys.length; i--; ) {
      if (e.keyCode === keys[i]) {
        preventDefault(e);
        return;
      }
    }
  }

  function wheel(e) {
    preventDefault(e);
  }

  function disable_scroll() {
    if (window.addEventListener) {
      window.addEventListener("DOMMouseScroll", wheel, false);
    }
    window.onmousewheel = document.onmousewheel = wheel;
    document.onkeydown = keydown;
  }

  function enable_scroll() {
    if (window.removeEventListener) {
      window.removeEventListener("DOMMouseScroll", wheel, false);
    }
    window.onmousewheel = document.onmousewheel = document.onkeydown = null;
  }

  function myAddParameterAndReturn(url, paramName, paramValue) {
    if (url.indexOf(paramName + "=") >= 0) {
      var prefix = url.substring(0, url.indexOf(paramName));
      var suffix = url.substring(url.indexOf(paramName));
      suffix = suffix.substring(suffix.indexOf("=") + 1);
      suffix =
        suffix.indexOf("&") >= 0 ? suffix.substring(suffix.indexOf("&")) : "";
      url = prefix + paramName + "=" + paramValue + suffix;
    } else {
      if (url.indexOf("?") < 0) url += "?" + paramName + "=" + paramValue;
      else url += "&" + paramName + "=" + paramValue;
    }
    return url;
  }

  var geoMarkers = [];
  var googleMapMarkers = [];

  function is_touch_device() {
    return (
      "ontouchstart" in window || // works on most browsers
      navigator.maxTouchPoints
    ); // works on IE10/11 and Surface
  }

  function requestMarkers(map, url, oms) {
    deleteMarkers();
    $.ajax({
      dataType: "json",
      url: url,
    }).done(function (json) {
      $.each(json, function (index, elem) {
        // console.log(elem);
        geoMarkers.push({
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [elem.address.lng, elem.address.lat],
          },
          properties: {
            postid: elem.post.ID,
            link: elem.permalink,
            marker: elem.markerIcon,
          },
        });
      });
      oms.removeAllMarkers();
      setMarkers(map, geoMarkers, oms);
    });
  }

  function setMarkers(map, geoMarkers, oms) {
    var geojson = {
      type: "FeatureCollection",
      features: geoMarkers,
    };

    //console.log(geojson);
    if (geojson.features.length >= 1) {
      var bounds = new google.maps.LatLngBounds();
      geojson.features.forEach(function (feature) {
        if (
          feature.geometry.coordinates[1] &&
          feature.geometry.coordinates[0]
        ) {
          var icon = new google.maps.MarkerImage(
            feature.properties.marker,
            new google.maps.Size(28, 39),
            null,
            null,
            new google.maps.Size(28, 39)
          );

          var markerpos = new google.maps.LatLng(
            feature.geometry.coordinates[1],
            feature.geometry.coordinates[0]
          );
          var marker = new google.maps.Marker({
            position: markerpos,
            map: map,
            title: "",
            animation: google.maps.Animation.DROP,
            url: feature.properties.link,
            icon: icon,
          });

          oms.addMarker(marker);
          //googleMapMarkers.push(marker);
          //  console.log(feature)
          google.maps.event.addListener(marker, "spider_click", function () {
            window.open(this.url);
          });
          bounds.extend(markerpos);
        }
      });
      google.maps.event.trigger(map, "resize");
      $(".loadingOverlay").hide();
      if (geoMarkers.length > 1) {
        map.fitBounds(bounds);
        setTimeout(function () {
          map.setZoom(map.getZoom() - 1);
        }, 100);
      } else {
        map.fitBounds(bounds);
        map.setZoom(12);
      }
    }
  }

  function deleteMarkers() {
    for (var i = 0; i < googleMapMarkers.length; i++) {
      googleMapMarkers[i].setMap(null);
    }
    googleMapMarkers = [];
    geoMarkers = [];
  }

  $(".gallery").lightGallery({
    selector: ".gallery-item a",
  });

  $(".galleryInner").lightGallery({
    selector: ".galItem",
  });

  $(".casawp-carousel").lightGallery({
    selector: ".property-image-gallery",
    download: false,
    thumbnail: false,
  });

  $(".casadistance__menu__button").on("click", function () {
    $("html, body").animate(
      {
        scrollTop: $(".casadistance__menu").offset().top,
      },
      500
    );
  });

  $(".navbar-toggler").on("click", function () {
    if ($(this).hasClass("active-nav")) {
      $(this).removeClass("active-nav");
      $(".navbarOuter").removeClass("nav-bg");
    } else {
      $(this).addClass("active-nav");
      $(".navbarOuter").addClass("nav-bg");
    }
  });

  $(".navbar-collapse").on("shown.bs.collapse", function () {
    $("#footer").hide();
    $("#content").hide();
    $(".sliderOuter").hide();
  });

  $(".navbar-collapse").on("show.bs.collapse", function () {
    $("html, body").animate(
      {
        scrollTop: $("html, body").offset().top,
      },
      500
    );
    $("#header").css("position", "absolute");
    $("html").addClass("navBackground");
  });

  $(".navbar-collapse").on("hidden.bs.collapse", function () {});

  $(".navbar-collapse").on("hide.bs.collapse", function () {
    $("#header").css("position", "fixed");
    $("#footer").show();
    $("#content").show();
    $(".sliderOuter").show();
    $("html").removeClass("navBackground");
  });

  $("#navigation .menu-item-has-children > a").on("click", function (e) {
    e.preventDefault();
    $(this).trigger("click");
    return false;
  });

  $(".wpml-ls > ul > li > a").on("click", function (e) {
    e.preventDefault();
    $(this).trigger("click");
    return false;
  });

  var textTop =
    $(
      ".casawp-shortcode-properties-shortcode-list .casawp-property"
    ).outerHeight() -
    $(
      ".casawp-shortcode-properties-shortcode-list .casawp-property .casawp-text h3"
    ).outerHeight();

  $(".casawp-shortcode-properties-shortcode-list .casawp-property").each(
    function (index, el) {
      textTop = $(el).outerHeight() - $(el).find("h3").outerHeight();
      $(el).find(".casawp-text").css("top", textTop);
    }
  );
 
  $(".casawp-shortcode-properties-shortcode-list .casawp-property").on(
    "click",
    function () {
      if ($(this).hasClass("activeProperty")) {
        $(this).removeClass("activeProperty");
      } else {
        $(
          ".casawp-shortcode-properties-shortcode-list .casawp-property"
        ).removeClass("activeProperty");
        $(this).addClass("activeProperty");
      }
    }
  );

  $(window).on("scroll", function () {
    if ($(".homeHeader--tester").length) {
      if($(".homeVideo").length){
        if (
          $(window).scrollTop() >
          $(".homeVideo").outerHeight() - $("#header").outerHeight()
        ) {
          $(".home #header").removeClass("homeHeader");
        } else {
          $(".home #header").addClass("homeHeader");
        }
      } else{
        if (
          $(window).scrollTop() >
          $(".homeSlider").outerHeight() - $("#header").outerHeight()
        ) {
          $(".home #header").removeClass("homeHeader");
        } else {
          $(".home #header").addClass("homeHeader");
        }
      }
    }
  });

  if ($(".homeHeader--tester").length) {
    if ($(window).scrollTop() > $(".homeSlider").outerHeight()) {
      $(".home #header").removeClass("homeHeader");
    } else {
      $(".home #header").addClass("homeHeader");
    }
  }

  if (!$(".navbar-collapse").hasClass("show")) {
    var myElement = document.querySelector("#header");
    // construct an instance of Headroom, passing the element
    var headroom = new Headroom(myElement, {
      offset: 205,
      tolerance: 5,
      classes: {
        initial: "animated",
        pinned: "slideDown",
        unpinned: "slideUp",
      },
    });
    // initialise
    headroom.init();
  }

  if ($(".casawp-shortcode-properties").length) {
    var shortFlickity = new Flickity(".casawp-shortcode-properties", {
      cellAlign: "left",
      contain: true,
      imagesLoaded: true,
      pageDots: true,
      prevNextButtons: false,
      draggable: true,
      autoPlay: 7000,
    });
    if (shortFlickity.slides.length <= 2) {
      $(".flickity-page-dots").hide();
    }
  }

  if ($(".co_slider").length) {
    var slider = new Flickity(".co_slider", {
      cellAlign: "left",
      wrapAround: true,
      imagesLoaded: true,
      pageDots: false,
      prevNextButtons: false,
      draggable: false,
      autoPlay: 7000,
    });
  }

  if ($(".grid").length) {
    var $grid = $(".grid").isotope({
      itemSelector: ".grid-item",
    });

    $grid.imagesLoaded().progress(function () {
      $grid.isotope({
        itemSelector: ".grid-item",
      });
    });
  }

  if ($(".filters-select").length) {
    $(".filters-select").select2();

    $(".filters-select").on("change", function () {
      // get filter value from option value

      var maxHeight = 0;

      $(".grid-item").each(function () {
        var thisH = $(this).height();
        if (thisH > maxHeight) {
          maxHeight = thisH;
        }
      });

      $(".grid-item").height(maxHeight);
      var filterValue = this.value;
      // console.log(filterValue);
      // use filterFn if matches value
      $grid.isotope({ filter: filterValue });
    });
  }

  window.addEventListener("load", function () {
    $(".chosen-single, .select2-selection").append(
      '<i class="fal fa-angle-down"></i>'
    );
  });

  $(".main-menu .menu-item-has-children > a, .wpml-ls-item a:first").append(
    '<i class="fal fa-angle-down"></i>'
  );

  $('<i class="fal fa-angle-down"></i>')
    .insertAfter(".form-control-singleselect")
    .hide();

  if (is_touch_device()) {
    $(".form-control-singleselect").nextAll().show();
  }

  $(".form-group select").parent().append('<i class="fal fa-angle-down"></i>');

  $(".toggle-map").on("click", function (e) {
    e.preventDefault();
    if ($(".map-wrap").hasClass("map-wrap--hidden")) {
      $(".map-wrap").removeClass("map-wrap--hidden");
      $(this).find(".show-map").addClass("d-none");
      $(this).find(".hide-map").removeClass("d-none");
      if ($("#casawp-map").length) {
        initializeMapBoxCasaWP();
        disable_scroll();
        $("html, body")
          .stop()
          .animate(
            {
              scrollTop:
                $("#casawp-map").offset().top - $("#header").outerHeight(),
            },
            700,
            function () {
              enable_scroll();
            }
          );
      }
    } else {
      $(".map-wrap").addClass("map-wrap--hidden");
      $(this).find(".show-map").removeClass("d-none");
      $(this).find(".hide-map").addClass("d-none");
      disable_scroll();
      $("html, body")
        .stop()
        .animate(
          {
            scrollTop: $(".map-wrap").offset().top - $("#header").outerHeight(),
          },
          700,
          function () {
            enable_scroll();
          }
        );
    }
    return false;
  });

  function initializeMapBoxCasaWP() {
    var style = [
      {
        elementType: "geometry",
        stylers: [
          {
            color: "#f5f5f5",
          },
        ],
      },
      {
        elementType: "labels.icon",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        elementType: "labels.text.fill",
        stylers: [
          {
            color: "#616161",
          },
        ],
      },
      {
        elementType: "labels.text.stroke",
        stylers: [
          {
            color: "#f5f5f5",
          },
        ],
      },
      {
        featureType: "administrative.land_parcel",
        elementType: "labels.text.fill",
        stylers: [
          {
            color: "#bdbdbd",
          },
        ],
      },
      {
        featureType: "poi",
        elementType: "geometry",
        stylers: [
          {
            color: "#eeeeee",
          },
        ],
      },
      {
        featureType: "poi",
        elementType: "labels.text.fill",
        stylers: [
          {
            color: "#757575",
          },
        ],
      },
      {
        featureType: "poi.park",
        elementType: "geometry",
        stylers: [
          {
            color: "#e5e5e5",
          },
        ],
      },
      {
        featureType: "poi.park",
        elementType: "labels.text.fill",
        stylers: [
          {
            color: "#9e9e9e",
          },
        ],
      },
      {
        featureType: "road",
        elementType: "geometry",
        stylers: [
          {
            color: "#ffffff",
          },
        ],
      },
      {
        featureType: "road.arterial",
        elementType: "labels.text.fill",
        stylers: [
          {
            color: "#757575",
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "geometry",
        stylers: [
          {
            color: "#dadada",
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [
          {
            color: "#616161",
          },
        ],
      },
      {
        featureType: "road.local",
        elementType: "labels.text.fill",
        stylers: [
          {
            color: "#9e9e9e",
          },
        ],
      },
      {
        featureType: "transit.line",
        elementType: "geometry",
        stylers: [
          {
            color: "#e5e5e5",
          },
        ],
      },
      {
        featureType: "transit.station",
        elementType: "geometry",
        stylers: [
          {
            color: "#eeeeee",
          },
        ],
      },
      {
        featureType: "water",
        elementType: "geometry",
        stylers: [
          {
            color: "#c9c9c9",
          },
        ],
      },
      {
        featureType: "water",
        elementType: "labels.text.fill",
        stylers: [
          {
            color: "#9e9e9e",
          },
        ],
      },
    ];

    var mapOptions = {
      center: { lat: 47.247913, lng: 8.674145 },
      zoom: 14,
      disableDefaultUI: false,
      zoomControl: true,
      mapTypeControlOptions: {
        mapTypeIds: ["roadmap", "hybrid"],
      },
      styles: style,
    };
    var map = new google.maps.Map(
      document.getElementById("casawp-map"),
      mapOptions
    );

    var oms = new OverlappingMarkerSpiderfier(map, {
      markersWontMove: false,
      markersWontHide: false,
      basicFormatEvents: false,
    });

    // set gray style
    map.mapTypes.set(
      "gray_map",
      new google.maps.StyledMapType([{ stylers: [{ saturation: -90 }] }], {
        name: "Karte",
      })
    );
    map.setMapTypeId("gray_map");

    if ($(".casawp-property").length > 0) {
      $(".loadingOverlay").removeAttr("style");
    }

    if (!$(".casawp-archive").hasClass("refArchive")) {
      var $form = $(".casawp-filterform");
      var filteredParams = $form.serialize();
      var url = $form.prop("action");
      url = url.replace(
        window.location.protocol + "//" + window.location.host,
        ""
      );
      var url_last = window.location.href.split("?");

      var filteredUrl = myAddParameterAndReturn(
        url + "?" + url_last[1],
        "ajax",
        "1"
      );
      //var filteredUrl = myAddParameterAndReturn(url + '?' + filteredParams, 'ajax', '1');
      filteredUrl = filteredUrl + "&posts_per_page=999&json=1";
      console.log(filteredUrl);
      requestMarkers(map, filteredUrl, oms);

      $(".casawp-filterform").on(
        "casawp-ajaxfilter:filter-submit",
        function (event, url, filteredUrl) {
          requestMarkers(
            map,
            filteredUrl + "&ajax=1&posts_per_page=999&json=1",
            oms
          );
        }
      );
    } else {
      requestMarkers(
        map,
        "/immobilien/?availabilities%5B%5D=reference&salestypes=&utilities=&categories=&locations=&rooms_from=&rooms_to=&features=&ajax=1&posts_per_page=100&json=1",
        oms
      );
    }
  }

  $("#chooseForm").on("submit", function (event) {
    event.preventDefault();
    $.ajax({
      type: "GET",
      url: window.location.href,
      data: { distance: "distance" },
      success: function (data) {
        initMap();
      },
    });
  });

  $(".casawp-ajax-archive-list").on(
    "casawp-ajaxfilter:after-list-reload",
    function (event, url, filteredUrl) {
      setTimeout(function () {
        $(".chosen-single").append('<i class="fal fa-angle-down"></i>');
      }, 500);
      var width = $(window).width();
      if (width <= 768) {
        $("html, body").animate(
          {
            scrollTop: $(".contentWrap").offset().top,
          },
          1000
        );
      }
    }
  );

  function initializeMap($mapwraper) {
    if ($(".marker").length) {
      var markerIcon = $(".marker").data("marker");
    }
    var location = new google.maps.LatLng(
      $mapwraper.data("lat"),
      $mapwraper.data("lng")
    );
    var mapOptions = {
      zoom: parseInt(window.casawpOptionParams.google_maps_zoomlevel),
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      center: location,
      mapTypeControlOptions: {
        mapTypeIds: [google.maps.MapTypeId.ROADMAP, "gray_map"],
      },
    };
    $mapwraper.show();
    var map = new google.maps.Map(
      document.getElementById("map-canvas"),
      mapOptions
    );

    var marker = new google.maps.Marker({
      map: map,
      position: location,
      icon: new google.maps.MarkerImage(
        markerIcon,
        new google.maps.Size(28, 39),
        null,
        null,
        new google.maps.Size(28, 39)
      ),
    });
    map.mapTypes.set(
      "gray_map",
      new google.maps.StyledMapType([{ stylers: [{ saturation: -90 }] }], {
        name: "Gray Map",
      })
    );
    map.setMapTypeId("gray_map");
  }

  if ($(".casawp-map").length && google) {
    $(".casawp-map").each(function () {
      var $mapwraper = $(this);
      if ($mapwraper.data("lat") && $mapwraper.data("lng")) {
        //var map;
        if ($("#casawp-mapShowBtn").length) {
          $("#casawp-mapShowBtn").on("click", function () {
            console.log("click");
            if ($("#casawp-mapShowBtn").length) {
              $("#casawp-mapShowBtn").css("display", "none");
            }
            if ($(".casawp-map__placeholder").length) {
              $(".casawp-map__placeholder").css("display", "none");
            }
            $(".casawp-map").css("display", "block");
            initializeMap($mapwraper);
          });
        } else {
          initializeMap($mapwraper);
        }
      }
    });
  }

  if ($(".wpforms-field.wpforms-field-select").length) {
    $(".wpforms-field.wpforms-field-select").each(function (index, fa) {
      $(fa).append('<i class="fal fa-angle-down"></i>');
    });
  }

  if ($(".wpforms-field-radio").length) {
    $(".wpforms-field-radio li label").append(
      '<span class="checkmark"></span>'
    );
  }
});



// WEBPACK FOOTER //
// ./src/js/main.js